import { Injectable } from '@angular/core';
import { LoadSheetDTO } from '@common/dto/loadsheet.dto';
import { ReportFilterDTO } from '@common/dto/reportFilter.dto';
import { FilterForSaleReturnScreen } from '@common/interface/customFilterForSaleReturnScreen';
import { IOrderImportInput } from '@common/interface/orderImportInterface';
import { ICompanySettingsInput } from '@common/models/companySettings.model';
import { IGetRowsParams } from 'ag-grid-community/dist/lib/interfaces/iDatasource';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { AppService } from '..//@core/service/App.Service';
import { IOrderInput } from '../@models';
import { agFilters, dailyOrderActivityDetailReportFilters, setFilterRequest } from '../shared/utility.functions';
import { baseProjection } from '@common/projection/base.projection';
@Injectable({ providedIn: 'root' })
export class OrderService extends AppService<any> {
  constructor(
    public toastr: ToastrService,
  ) {
    super('Order');
  }
  verifyProductData: any;
  scanAndPackedOrderObj;
  setData = new Subject<any>()
  setCourierData = new Subject<any>()
  async getAll() {
    return await this.get('');
  }

  async getAllByCustomerId(customerId: any) {
    return await this.get(`/customerId`, customerId);
  }

  async getOrderById(orderId: any) {
    return await this.get('', orderId);
  }

  async getAllFiltered(order: any) {
    return await this.get(`/filtered`, order);
  }

  async getOrderProductsToVerifyReturn(orderId: number) {
    return await this.get(`/getOrderProductsToVerifyReturn/${orderId}`);
  }

  async getGeneratedOrderReference(companyId: any) {

    return await this.get(`/getGeneratedOrderReference/${companyId}`);
  }

  async add(order: IOrderInput) {
    return await this.post('', order);
  }

  async bulkAdd(orders: IOrderImportInput[]) {
    return await this.post('/bulkPost', orders);
  }

  async update(order: IOrderInput, orderId: any) {

    return await this.put(`/${orderId}`, order);
  }

  async updateReason(reason: any, orderId: any) {
    return await this.put(`/updateReason/${orderId}`, reason);
  }

  async updateDiscrepancyRemarks(discrepancyRemarks: any, orderId: any) {
    return await this.put(`/updateDiscrepancyRemarks/${orderId}`, discrepancyRemarks);
  }

  async updateReturnProductRemark(obj) {
    return await this.put(`/updateReturnProductRemark/${obj?.orderId}`, obj);
  }

  async updateField(field: any, orderId: any) {
    return await this.patch(`/${orderId}`, field);
  }

  async assignWarehouseToOrders(data: {orderIds: number[], shippingWarehouseId: number}) {
    return await this.post(`/assignWarehouseToOrders`, data);
  }

  async updateDetailField(field: any, orderId: any) {
    return await this.patch(`/orderDetail/${orderId}`, field);
  }

  async replacementOrder(orders: any) {
    return await this.post(`/replacementOrder`, orders);
  }

  async copyOrder(order: IOrderInput) {
    return await this.post(`/copyOrder`, order);
  }

  async addSplitOrder(order: IOrderInput) {
    return await this.post(`/splitOrder`, order);
  }

  async applyManualShipment(order: IOrderInput, orderId: any) {
    return await this.put(`/applyManualShipment/${orderId}`, order);
  }

  async delete(httpParams: any) {
    return await this.del('', httpParams);
  }

  async assignTags(orders: IOrderInput[], tags: any) {
    return await this.post(`/assignTags/${tags}`, orders);
  }

  async removeTags(orders: IOrderInput[], tags: any) {
    return await this.post(`/removeTags/${tags}`, orders);
  }

  async bulkDelete(orders: IOrderInput[]) {
    return await this.post('/bulkDelete', orders);
  }

  async applyLogistic(orders: any) {
    return await this.post('/applyLogistic', orders);
  }

  async apply_inside_logistic(orders: any) {
    return await this.post('/applyInsideLogistic', orders);
  }

  async applyManualConsignmentToOrder(orders) {
    return await this.post('/applyManualConsignmentToOrder', orders);
  }

  printLoadSheetReport(dto: LoadSheetDTO): Observable<any> {
    return this.downloadFile('/loadsheet', dto);
  }

  printReport(tableData: any): Observable<any> {
    return this.downloadFile('/printReport', tableData);
  }

  printPackingSheetReport(query: any): Observable<any> {

    return this.downloadFile('/packingsheet', query);
  }
  async GetPackingSheetOrdersSpecifiedStatus(query: any) {

    return await this.post('/packingsheetordersforspecifiedorder', query);
  }

  async printPackingSheetReportAsExcel(query: any) {

    return await this.post(`/packingsheetData`, query);
  }

  saleInvoicePrint(orders: any): Observable<any> {
    return this.downloadFile('/saleInvoicePrint', orders);
  }

  async cancelShipments(orders: any) {
    return await this.post('/cancelShipments', orders);
  }

  async filterOrders(cnNumbers: any) {
    return await this.post('/filter', cnNumbers);
  }

  async getReceiveMoneyOrders(filter: any) {
    return await this.post('/receiveMoneyOrders', filter);
  }

  filterForReturnOrReplacementOrders(agParams: IGetRowsParams, searchText: string = "", customFilters: FilterForSaleReturnScreen) {
    let filters = setFilterRequest(agParams, searchText, customFilters);
    return this.postObservable('/filterForReturnOrReplacementOrders', filters);
  }

  async filterCustomerOrders(cnNumbers: any) {
    return await this.post('/filtercustomerorders', cnNumbers);
  }

  async filterOrdersWithSpecificDate(cnNumbers: any) {
    return await this.post('/filterBydate', cnNumbers);
  }

  async filterOrdersWithSpecificDateAndCourier(object: any) {
    return await this.post('/filterByDateAndCourier', object);
  }

  async getCourierTracking(orderId: any) {
    return await this.get('/getTracking', orderId);
  }

  addressLabelPrint(orders: any): Observable<any> {
    return this.downloadFile('/addressLabelPrint', orders);
  }

  addressLabelWithInvoicePrint(orders: any): Observable<any> {
    return this.downloadFile('/addressLabelWithInvoicePrint', orders);
  }

  addressLabelPrint4By6(orders: any): Observable<any> {
    return this.downloadFile('/addressLabelPrint4By6', orders);
  }

  async changeStatus(orders: any) {
    return await this.post('/changeStatus', orders);
  }

  async getBestEstimatedDaysShippingCarrier(orderArr: any) {
    return await this.post('/bestEstimatedDaysShippingCarrier', orderArr);
  }


  getDataForLoadsheetReport(companyId: any = 0, agParams: any, searchText: string = "", customFilters) {
    let filters = setFilterRequest(agParams, searchText, customFilters);
    return this.postObservable(`/loadsheetReport/${companyId}`, filters);
  }

  async getDataForLoadsheetDetailReport(loadSheetId: any) {
    return this.get(`/loadSheetDetailReport/${loadSheetId}`);
  }

  async getOrdersByReceiveMoneyId(receiveMoneyId: number) {
    return await this.get(`/getOrdersByReceiveMoneyId/${receiveMoneyId}`);
  }

  async GetOrdersByIds(orderIds: number[]) {
    return await this.get(`/ordersByIds/${orderIds}`);
  }

  async getGroupStatusData<T extends baseProjection>(type: T, companyId: string) {
    return await this.get(`/getGroupStatusData/${companyId}`, null, { projection: type.name });
  }

  async getOrdersByShippingCarrierId(shippingCarrierId: any) {
    return await this.get(`/shippingCarrierId/${shippingCarrierId}`);
  }

  async getPackedStatusOrder(beforeBooked: boolean) {
    return await this.get(`/getPackedStatusOrder/${beforeBooked}`);
  }

  async getOrdersForDailyReport(data: any) {
    return await this.post('/ordersForDailyReport', data);
  }

  async getOrdersByStatus(status: string, fromDate: string, toDate: string, timezone: string, shippingCarrierId: string, orderType: number) {
    return await this.get(`/getOrdersByStatus/${status}/${fromDate}/${toDate}/${timezone.replace("/", "_")}/${shippingCarrierId}/${orderType}`);
  }
  async getOrdersForDailyDetailReport(data: any) {
    return await this.post('/ordersForDailyDetailReport', data);
  }

  async getOrdersForDailyActivityReport(data: any) {
    return await this.post('/ordersForDailyActivityReport', data);
  }

  getOrdersDetailForDailyActivityReport(agParams: IGetRowsParams, customFilters: FilterForSaleReturnScreen) {
    let filters = dailyOrderActivityDetailReportFilters(agParams, customFilters);
    return this.postObservable('/ordersDetailForDailyActivityReport', filters);
  }

  async verifyReturn(body: any) {
    return await this.post(`/verifyReturn`, body);
  }

  async verifyPacking(body) {
    return await this.post(`/verifyPacking`, body);
  }

  async pendingCourierOrders(data: any) {
    return await this.post('/pendingCourierOrders', data);
  }
  async pendingReturnReplacementOrdersReport(data: ReportFilterDTO) {
    return await this.post('/pendingReturnReplacementOrdersReport', data);
  }

  async recurringCustomerOrderReport(data: ReportFilterDTO) {
    return await this.post('/recurringCustomerOrderReport', data);
  }

  async getSummaryPendingOrder(companyId: string) {
    return await this.get(`/getSummaryPendingOrder/${companyId}`);
  }

  async getCourierChargesDiscrepancy(companyId: string, fromDate: Date, toDate: Date, timeZone: string) {
    return await this.get(`/getCourierChargesDiscrepancy/${companyId}/${fromDate}/${toDate}/${timeZone}`);
  }

  async orderDetailReport(data: any) {
    return await this.post('/orderDetailReport', data);
  }

  async pendingOrderPaymentReport(data: any) {
    return await this.post('/pendingOrderPaymentReport', data);
  }

  async cancelledReturnOrderReport(data: any) {
    return await this.post('/cancelledReturnOrderReport', data);
  }

  async courierPerformanceReport(data: ReportFilterDTO) {
    return await this.post('/courierPerformanceReport', data);
  }

  async replacementOrderReport(data: any) {
    return await this.post('/replacementOrderReport', data);
  }

  async applyFilterCustomerHistory(data: any) {
    return await this.post('/applyFilterCustomerHistory', data);
  }

  async saleReturnGroupedData(companyId: string) {
    return await this.get(`/saleReturnGroupedData/${companyId}`);
  }

  async syncOrdersManually(body: ICompanySettingsInput) {
    return await this.post('/syncOrdersManually', body);
  }

  async fetchOrderStatusesManually(orderIds: number[]) {
    return await this.post('/fetchOrderStatusesManually', { orderIds: orderIds });
  }

  async updateCustomerOrderCity(field: { shipping: { isSameAsBilling: boolean, city: string }, tagId: string }, orderId: number) {
    return await this.patch(`/updateCustomerOrderCity/${orderId}`, field);
  }

  async verifyBulkReturn(orderIds: number[]) {
    return await this.post(`/verifyBulkReturn`, { orderIds: orderIds });
  }

  async unVerifyReturn(orderId: number) {
    return await this.post(`/unVerifyReturn`, { orderId: orderId });
  }

  async filterOrdersForScanAndPack(body) {
    return await this.post('/filterOrdersForScanAndPack', body);
  }

  async getProductBySerialNumber(sku: string, warehouseId: number, serial: string) {
    return await this.get(`/getProductBySerialNumber/${sku}/${warehouseId}/${serial}`);
  }

  async isSerialNumberMappedInOrders(flag: boolean) {
    return await this.get(`/isSerialNumberMappedInOrders/${flag}`);
  }

  async bulkSoftDelete(orderIds: number[], id: number) {
    return await this.put(`/bulkSoftDeleteOrders/${id}`, orderIds);
  }

  async initializeOrderList(body) {
    return await this.post('/initializeOrderList', body);
  }

  async updateOrderCellValue(body, id: number) {
    return await this.put(`/updateOrderCellValue/${id}`, body);
  }
}
